import { render } from "./404.vue?vue&type=template&id=c186f2ee&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=c186f2ee&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c186f2ee"]])

export default __exports__